import store from "../store";
import { commonService } from "./common.service";
import { env } from "../env";

export const renouvellementService = {
  getRenouvellementsByParcId,
  postRenouvellement,
  deleteRenouvellementById,
  putRenouvellement
};

function getRenouvellementsByParcId(parcId) {
  const url = new URL(`${env.apiUrl}/renouvellements/parcs/${parcId}`);

  return commonService.getRessource(url);
}

function postRenouvellement(renouvellement) {
  const url = new URL(`${env.apiUrl}/renouvellements`);

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + store.getters.token,
    },
    body: JSON.stringify(renouvellement)
  };

  return fetch(url, requestOptions)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}

function deleteRenouvellementById(renouvellementId) {
  const url = new URL(`${env.apiUrl}/renouvellements/${renouvellementId}`);

  const requestOptions = {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + store.getters.token,
    }
  };

  return fetch(url, requestOptions)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}

function putRenouvellement(renouvellement) {
  const url = new URL(`${env.apiUrl}/renouvellements`);

  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + store.getters.token,
    },
    body: JSON.stringify(renouvellement)
  };

  return fetch(url, requestOptions)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}
